export default {
  name: 'LoadingState',
  props: {
    loading: {
      type: Boolean,
      default: true,
      required: true
    },
    color: {
      type: String,
      default: 'primary',
      required: false
    }
  }
}
